import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssessmentRequestService } from 'src/app/assess-requests/assess-requests.service';
import { ruleFlags } from 'src/app/common/models/PureRuleDetailsModel';
import { DataService } from 'src/app/common/services/data.service';
import { environment } from 'src/environments/environment';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-edit-rules',
  templateUrl: './edit-rules.component.html',
  styleUrls: ['./edit-rules.component.scss']
})
export class EditRulesComponent implements OnInit {
  selectedRuleBucket: string;
  ruleDetailsToEdit;
  activeTabUR = 'update-rule';
  goToWorklistConfirmation = false;
  expandedView = false;
  loadingMsg = 'Fetching data from FAST Rule-Engine';
  loading = false;
  getRuleData;
  editRuleFlag = false;
  viewRuleFlag = false;
  disableViewToEdit = false;
  childRefreshKey = 0;
  constructor(
    public dataSvc: DataService,
    private route: Router, private router: ActivatedRoute,
    private activatedRoute: ActivatedRoute,
    private assessRequestRa: AssessmentRequestService
  ) { }
  /* istanbul ignore next */
  ngOnInit() {
    this.loading = true;
    const queryParams = this.activatedRoute.snapshot.queryParamMap;
    const mode = (queryParams.get('mode') || '').toLowerCase();
    const queryRuleId = queryParams.get('ruleId');
    const queryRuleTypeID = queryParams.get('ruleTypeID');
    const queryRuleVersion = queryParams.get('ruleVersion');
    const queryRuleStatus = queryParams.get('ruleStatus');
    const hasQueryRouteContext = !!queryRuleId && !!queryRuleTypeID && !!mode;

    if (hasQueryRouteContext) {
      this.ruleDetailsToEdit = {
        ruleId: queryRuleId,
        ruleTypeID: queryRuleTypeID,
        ruleVersion: queryRuleVersion ? 'V' + String(queryRuleVersion).replace(/^V/i, '') : '',
        ruleStatus: queryRuleStatus || ''
      };
      this.dataSvc.setViewruleToEdit(this.ruleDetailsToEdit);
    } else {
      this.dataSvc.getViewruleToEdit().pipe(take(1)).subscribe((val) => {
        if (val && val.ruleId && val.ruleTypeID) {
          this.ruleDetailsToEdit = val;
        }
      });
    }

    if (mode === 'view') {
      ruleFlags.viewRule = true;
      ruleFlags.editRule = false;
      this.editRuleFlag = false;
      this.viewRuleFlag = true;
    } else if (mode === 'edit') {
      ruleFlags.viewRule = false;
      ruleFlags.editRule = true;
      this.editRuleFlag = true;
      this.viewRuleFlag = false;
    } else if (ruleFlags.viewRule) {
      this.editRuleFlag = false;
      this.viewRuleFlag = true;
    } else if (ruleFlags.editRule) {
      this.editRuleFlag = true;
      this.viewRuleFlag = false;
    }

    if (!this.ruleDetailsToEdit || !this.ruleDetailsToEdit.ruleId || !this.ruleDetailsToEdit.ruleTypeID) {
      this.loading = false;
      return;
    }

    this.loading = true;
    this.loadingMsg = 'Fetching data from FAST Rule-Engine';
    const normalizedRuleId = String(this.ruleDetailsToEdit.ruleId).trim();
    const normalizedRuleTypeId = String(this.ruleDetailsToEdit.ruleTypeID).trim();
    let apiurl = environment.APIFAsTRule + '/rules/ruleID/' + normalizedRuleId + '/ruleType/' + normalizedRuleTypeId;
    if (this.viewRuleFlag) {
      let ruleVer = this.ruleDetailsToEdit.ruleVersion || '';
      ruleVer = String(ruleVer).replace(/^V/i, '');
      apiurl = environment.APIFAsTRule + '/rules/ruleID/' + normalizedRuleId + '/ruleType/' + normalizedRuleTypeId + '/ruleVersion/' + String(ruleVer).trim();
    }
    this.assessRequestRa.getData(apiurl).subscribe((response) => {
      if (response) {
        this.loading = false;
        this.getRuleData = response;
        this.getRuleData[0].ruleStatus = this.ruleDetailsToEdit.ruleStatus;
        const normalizedStatus = String(this.getRuleData[0].ruleStatus || '').toLowerCase().replace(/[^a-z]/g, '');
        this.getRuleData[0].isFutureActiveRule = normalizedStatus === 'futureactive';
        this.disableViewToEdit = this.viewRuleFlag && this.getRuleData[0].isFutureActiveRule === true;
        if (response[0].ruleClassification === 'Substance Based Rules' || response[0].ruleClassification === 'Substance Group Rules' || response[0].ruleClassification === 'Property Based Rules' || response[0].ruleClassification === 'Product Based Rules') {
          this.setRuleBucket(response[0].ruleClassification);
        }
        this.dataSvc.setruleToEdit(response[0]);
        response[0].ruleTypeId = response[0].ruleTypeID;
        response[0].ruleTypeDisplayName = response[0].ruleType;
        response[0].isViewMode = this.viewRuleFlag;
        response[0].isEditMode = this.editRuleFlag;
        if (response[0].ruleClassification === 'Substance Based Rules') {
          if (response[0].ruleTypeId === 50) {
            this.dataSvc.setSelectedRuleType(response);
          } else {
            this.dataSvc.setSelectedRuleType(response[0]);
          }
          this.dataSvc.setExpandablePanel(3);
        } else if (response[0].ruleClassification === 'Substance Group Rules') {
          if (response[0].ruleTypeId === 51) {
            this.dataSvc.setSelectedGroupRuleType(response);
          } else {
            this.dataSvc.setSelectedGroupRuleType(response[0]);
          }
          this.dataSvc.setParallelRuleFormValues(null);
          this.dataSvc.setExpandablePanel(1);
        } else if (response[0].ruleClassification === 'Property Based Rules' || response[0].ruleClassification === 'Product Based Rules') {
          this.dataSvc.setSelectedProductRuleType(response[0]);
          this.dataSvc.setExpandablePanel(2);
        }
      }
    }, (error) => {
      this.loading = false;
    });
  }
  setRuleBucket(ruleBucketValue) {
    this.selectedRuleBucket = ruleBucketValue;
    if (ruleBucketValue === 'Product Based Rules') {
      this.dataSvc.setExpandablePanel(2);
    } else if (ruleBucketValue === 'Substance Based Rules') {
      this.dataSvc.setExpandablePanel(3);
    } else if (ruleBucketValue === 'Substance Group Rules') {
      this.dataSvc.setExpandablePanel(3);
    }
  }
  /* istanbul ignore next */
  navigateToViewRules() {
    this.route.navigateByUrl('/home', { skipLocationChange: true }).then(() => {
      this.route.navigate(['/rule-management/view-rules']);
    });
  }
  /* istanbul ignore next */
  navigateToSubstanceSearch() {
    this.dataSvc.fromViewtoSubstance = true;
    this.route.navigate(['/substance-search/1']);
  }
  /* istanbul ignore next */
  viewEditRule() {
    if (this.disableViewToEdit) {
      return;
    }
    this.viewRuleFlag = false;
    this.editRuleFlag = true;
    ruleFlags.viewRule = false;
    ruleFlags.editRule = true;
    this.dataSvc.setViewruleToEdit(this.ruleDetailsToEdit);
    this.dataSvc.setViewToEditStep(1);
    this.childRefreshKey++;
    this.route.navigate(['rule-management/view-rules/edit-rules']);
  }
}
